import i18next from "@config/i18next";
import { AsyncActionCreatorFactory } from "@services/AsyncActionCreatorFactory";
import { versionRefresherMiddleware } from "@services/VersionRefresherMiddleware";
import { showToast } from "@containers/Toastify";

const middleware =
  process.env.NODE_ENV === "production" ? [versionRefresherMiddleware] : [];

const onFetchErrorNotification = (customMessage?: string) => {
  const message = String(
    customMessage || i18next.t("batmaid_pwa_generic.something_went_wrong"),
  );

  showToast(message, {
    type: "error",
    toastId: "generic-www-error",
  });
};

const asyncActionCreator = AsyncActionCreatorFactory({
  onFetchErrorNotification,
  invalidValueText: i18next.t("batmaid_pwa_generic.invalid_value"),
  middleware,
});

export { asyncActionCreator };
